// ** Third Party Components
import styled from "styled-components";

// ####################################################

export const StyledAttachmentDialogPicture = styled("img")`
	margin: 0 auto;
	max-height: 100%;
	max-width: 100%;
	height: auto;
	z-index: 1000;
	background-color: #303030;
`;

// ####################################################
